import React, { FC } from 'react';
import { useFinalizeMessageMutation } from '../../message/message.service';
import { toast } from 'react-toastify';
import cls from './CloseDialogButton.module.scss';
import { useNavigate } from 'react-router-dom';
import routes from '../../../routes';

type CloseDialogButtonProps = {
  id: string;
};

const CloseDialogButton: FC<CloseDialogButtonProps> = ({ id }) => {
  const [finalizeDialog] = useFinalizeMessageMutation();
  const navigate = useNavigate();
  const closeDialogHandler = async () => {
    await finalizeDialog(id);
    navigate(routes.pages.messagesPage());
    toast.success('Dialog completed');
  };
  return (
    <button className={cls.Button} onClick={closeDialogHandler} title="Complete">
      Complete
    </button>
  );
};

export default CloseDialogButton;
